import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

import * as DateIconStyle from "Styles/DateIcon"

const DateIcon = ({ date }) => {
  let day = moment(date).format("D")
  let month = moment(date).format("MMM")
  let year = moment(date).format("YYYY")

  return (
    <DateIconStyle.Icon>
      <div className="month">{month}</div>
      <div className="day">{day}</div>
      {/* {year !== moment().format("YYYY") && <div className="year">{year}</div>} */}
      <div className="year">{year}</div>
    </DateIconStyle.Icon>
  )
}

export default DateIcon

DateIcon.propTypes = {
  date: PropTypes.string.isRequired,
}

DateIcon.defaultProps = {
  date: moment(),
}
